import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import {
  Modal, Popup, Icon, Loader
} from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import api from '../../api';
import CLARLoader from '../Loader/Loader';
import WithRouter from '../Extensions/WithRouter';
//import history from '../Extensions/History';
import './Login.css';

class Login extends Component {
  constructor(props) {
    super(props);
    this.emailRef = React.createRef();
    this.passRef = React.createRef();
    this.modalAction = null;
    this.modalBody = null;
    this.onSubmit = this.onSubmit.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.confirmAdmin = this.confirmAdmin.bind(this);
    this.confirmAdminWithBcrypt = this.confirmAdminWithBcrypt.bind(this);
    this.resetAuthorizationError = this.resetAuthorizationError.bind(this);
    this.handlePasswordChange = this.handlePasswordChange.bind(this);
    this.handlePasswordConfirmationChange = this.handlePasswordConfirmationChange.bind(this);
    this.handleLogin = this.handleLogin.bind(this);
    this.handleConfirm = this.handleConfirm.bind(this);
    this.handleResetPassword = this.handleResetPassword.bind(this);
    this.handleInputRecoveryEmail = this.handleInputRecoveryEmail.bind(this);
    this.state = {
      isLoading: false,
      isOpenModal: false,
      isOpenSelectModal: false,
      isOpenConfirmModal: false,
      isNewType: false,
      email: {
        error: false,
        value: '',
        errorMsg: 'INVALID',
      },
      pass: {
        error: false,
        value: '',
        errorMsg: 'INVALID',
      },
      authorizationError: '',
      currentPassword: '',
      password: '',
      passwordConfirmation: '',
      passwordError: '',
      passwordConfirmationError: '',
      isRecoverPasswordLink: false,
      isShowLoader: false,
      recoveryEmail: '',
      recoveryEmailError: '',
    };
  }

  componentDidMount() {
    this.checkLogout();
  }

  componentDidUpdate(prevProps) {
    const { location } = this.props;
    if (location !== prevProps.location) {
      this.checkLogout();
    }
  }

  handleLogin(event) {
    if (event.key === 'Enter') {
      this.onSubmit();
    }
  }

  handleConfirm(event) {
    const { isNewType } = this.state;
    if (event.key === 'Enter') {
      if (!isNewType) {
        this.confirmAdmin();
      } else {
        this.confirmAdminWithBcrypt();
      }
    }
  }

  handlePasswordChange(e) {
    this.setState({
      password: e.target.value,
      passwordError: '',
    });
  }

  handlePasswordConfirmationChange(e) {
    this.setState({
      passwordConfirmation: e.target.value,
      passwordConfirmationError: '',
    });
  }

  handleInputRecoveryEmail(e) {
    this.setState({
      recoveryEmail: e.target.value,
      recoveryEmailError: '',
    });
  }

  handleResetPassword() {
    const { t } = this.props;
    this.modalAction = t('modal.title.attention');
    this.modalBody = t('login.message.reset_password');
    this.setState({
      isOpenSelectModal: true,
    });
  }

  onSubmit(event) {
    const { email, pass } = this.state;
    const {
      state, t, i18n, navigate
    } = this.props;

    this.setState({
      isLoading: true,
    });

    if (event) event.preventDefault();
    //hago comprobaciones
    //const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (
      this.emailRef.current.value.toLowerCase() === 'admin'
      || this.emailRef.current.value.toLowerCase() === 'licensemanager'
    ) {
      this.setState({
        email: {
          ...email,
          error: false,
        }
      });
    } else if (
      !this.emailRef
      || this.emailRef.current.value === ''
      //|| !re.test(this.emailRef.current.value)
    ) {
      this.setState({
        email: {
          ...email,
          error: true,
          errorMsg: t('login.error.error_email_required'),
        }
      });
    } else {
      this.setState({
        email: {
          ...email,
          error: false,
        }
      });
    }

    if (!this.passRef || this.passRef.current.value === '') {
      this.setState({
        pass: {
          ...pass,
          error: true,
          errorMsg: t('login.error.error_password_required'),
        }
      });
    } else {
      this.setState({
        pass: {
          ...pass,
          error: false,
        }
      });
    }

    this.resetAuthorizationError();

    //si no hay error envio
    if (!email.error && !pass.error) {
      //armo objeto para el envio
      const data = {
        email: this.emailRef.current.value,
        password: this.passRef.current.value,
        grant_type: 'password',
      };

      //envio
      api
        .getLogin(data)
        .then()
        .then((response) => {
          this.setState({
            isLoading: false,
          });
          state.user.setSession(response);
          this.access_token = response.access_token;
          api.getUserProfile(this.access_token).then((rsp) => {
            let locale;
            const res = rsp.response;
            if (res.locale === 'ko') {
              locale = 'kr';
            } else if (res.locale === 'ja') {
              locale = 'ja';
            } else {
              locale = 'en';
            }
            i18n.changeLanguage(locale);
            localStorage.setItem('i18nextLng', locale);
            state.user.setUserProfile(res);
            if (res.main_page === 'dashboard') {
              navigate('/main', { replace: true });
            } else if (res.main_page === 'results') {
              navigate('/results', { replace: true });
            } else {
              navigate(`/results/${state.user.main_page}`, { replace: true });
            }
            if (response.required_setting) {
              localStorage.setItem('required_setting', response.required_setting);
              //state.user.setRequiredSetting(response.required_setting);
            }
          });
        })
        .catch((err) => {
          console.log(err);
          this.setState({
            isLoading: false,
          });
          if (typeof err === 'undefined' || typeof err.data === 'undefined') {
            const authorizationError = t('login.error.error_database');
            this.setState({
              authorizationError,
              isNewType: false,
            });
            return false;
          }

          const o = err.data.response;

          if (!o && err.data.error === '401-014') {
            const authorizationError = t('login.error.error_401_014');
            this.setState({
              authorizationError,
              isNewType: false,
            });
            this.passRef.current.value = '';
            return false;
          }

          if (err.status === 500) {
            const authorizationError = t('login.error.error_database');
            this.setState({
              authorizationError,
              isNewType: false,
            });
          }

          if (o.error === '401-012') {
            this.setState({
              isNewType: true,
              isOpenModal: true,
              currentPassword: this.passRef.current.value,
            }, () => {
              setTimeout(() => {
                if (this.passwordInput) {
                  this.passwordInput.focus();
                }
              }, 1);
            });
            return false;
          }

          if (o.error === '401-001') { //invalid_grant
            const authorizationError = t('login.error.error_401_001');
            this.setState({
              authorizationError,
              isNewType: false,
            });
            return false;
          }

          if (o.error === '401-002') { //password_change_required
            this.setState({
              isOpenModal: true,
              isNewType: false,
              currentPassword: this.passRef.current.value,
            }, () => {
              setTimeout(() => {
                if (this.passwordInput) {
                  this.passwordInput.focus();
                }
              }, 1);
            });
            return false;
          }

          if (o.error === '401-003') { //user_not_active
            const authorizationError = t('login.error.error_401_003');
            this.setState({
              authorizationError,
              isNewType: false,
            });
            this.passRef.current.value = '';
            return false;
          }

          if (o.error === '401-004') { //invalid_request
            //The request is missing a required parameter, includes an unsupported parameter value, or is otherwise malformed.
            const authorizationError = t('login.error.error_401_004');
            this.setState({
              authorizationError,
              isNewType: false,
            });
            return false;
          }

          if (o.error === '401-013') { //user_not_active
            const authorizationError = t('login.error.error_401_013');
            this.setState({
              authorizationError,
              isNewType: false,
            });
            this.passRef.current.value = '';
            return false;
          }

          if (o.error === '401-014') {
            const authorizationError = t('login.error.error_401_014');
            this.setState({
              authorizationError,
              isNewType: false,
            });
            this.passRef.current.value = '';
            return false;
          }

          if (o.error === '401-015') {
            const authorizationError = t('login.error.error_401_015');
            this.setState({
              authorizationError,
              isNewType: false,
              isRecoverPasswordLink: true,
            });
            this.passRef.current.value = '';
            return false;
          }

          this.setState({
            isLoading: false,
          });
        });
    } else {
      this.setState({
        isLoading: true,
        email: {
          ...email,
          error: false,
        },
        pass: {
          ...pass,
          error: false,
        }
      });
    }
  }

  checkLogout = () => {
    const { location } = this.props;
    if (location.pathname === '/logout') {
      this.logout();
    }
  };

  resetPasswordWithToken = () => {
    const { t } = this.props;
    this.setState({
      isShowLoader: true,
    }, () => {
      api
        .resetPasswordWithToken()
        .then(() => {
          this.modalAction = t('modal.title.notice');
          this.modalBody = t('modal.message.sent_email');
          this.setState({
            isShowLoader: false,
            isOpenSelectModal: false,
            isOpenConfirmModal: true,
          });
        })
        .catch((err) => {
          console.log(err);
          const o = err.data.response;
          if (o.error === '422-367') {
            this.modalAction = t('modal.title.attention');
            this.modalBody = t('modal.error.error_422_367');
          } else if (o.error === '422-368') {
            this.modalAction = t('modal.title.attention');
            this.modalBody = t('modal.error.error_422_368');
          } else if (o.error_description) {
            this.modalAction = t('modal.title.attention');
            this.modalBody = o.error_description;
          } else {
            this.modalAction = t('modal.title.attention');
            this.modalBody = t('modal.error.unknow_error');
          }
          this.setState({
            isShowLoader: false,
            isOpenSelectModal: false,
            isOpenConfirmModal: true,
          });
        });
    });
  };

  logout() {
    const { state, navigate } = this.props;
    state.user
      .signOut()
      .then(() => {
        localStorage.removeItem('session');
        localStorage.removeItem('main_page');
        navigate('/login', { replace: true });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  confirmAdmin(event) {
    const { t } = this.props;
    const {
      recoveryEmail, password, passwordConfirmation, currentPassword
    } = this.state;
    let data;
    if (event) event.preventDefault();
    if (!this.checkPassword(password)) {
      this.setState({
        passwordError: t('modal.error.error_char_password'),
        passwordConfirmationError: '',
      });
      return false;
    }
    if (password !== passwordConfirmation) {
      this.setState({
        passwordError: '',
        passwordConfirmationError: t('modal.error.error_match_confirm_password'),
      });
      return false;
    }

    if (recoveryEmail.trim().length !== 0) {
      const isValidEmailAddressRegx = String(recoveryEmail).toLowerCase().match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
      if (!isValidEmailAddressRegx) {
        this.setState({
          passwordError: '',
          passwordConfirmationError: '',
          recoveryEmailError: t('modal.error.invalid_email_address'),
        });
        return false;
      }
    }

    if (recoveryEmail.trim().length !== 0) {
      data = {
        email: this.emailRef.current.value,
        current_password: currentPassword,
        password,
        password_confirmation: passwordConfirmation,
        recovery_email: recoveryEmail,
      };
    } else {
      data = {
        email: this.emailRef.current.value,
        current_password: currentPassword,
        password,
        password_confirmation: passwordConfirmation,
      };
    }

    api
      .confirmAdmin(data)
      .then()
      .then(() => {
        this.passRef.current.value = password;
        this.onSubmit();
        this.closeModal();
      })
      .catch((err) => {
        console.log(err);
        const o = err.data.response;
        if (o.error === '422-366') {
          this.setState({
            passwordError: '',
            passwordConfirmationError: '',
            recoveryEmailError: o.error_description,
          });
        }
      });
  }

  confirmAdminWithBcrypt() {
    const { t } = this.props;
    const {
      recoveryEmail, password, passwordConfirmation, currentPassword
    } = this.state;
    let data;

    if (event) event.preventDefault();
    if (!this.checkPassword(password)) {
      this.setState({
        passwordError: t('modal.error.error_char_password'),
        passwordConfirmationError: '',
      });
      return false;
    }
    if (password !== passwordConfirmation) {
      this.setState({
        passwordError: '',
        passwordConfirmationError: t('modal.error.error_match_confirm_password'),
      });
      return false;
    }

    if (recoveryEmail.trim().length !== 0) {
      const isValidEmailAddressRegx = String(recoveryEmail).toLowerCase().match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
      if (!isValidEmailAddressRegx) {
        this.setState({
          passwordError: '',
          passwordConfirmationError: '',
          recoveryEmailError: t('modal.error.invalid_email_address'),
        });
        return false;
      }
    }

    if (recoveryEmail.trim().length !== 0) {
      data = {
        email: this.emailRef.current.value,
        current_password: currentPassword,
        password,
        password_confirmation: passwordConfirmation,
        recovery_email: recoveryEmail,
      };
    } else {
      data = {
        email: this.emailRef.current.value,
        current_password: currentPassword,
        password,
        password_confirmation: passwordConfirmation,
      };
    }

    api
      .confirmAdminWithBcrypt(data)
      .then(this.setState())
      .then(() => {
        this.passRef.current.value = password;
        this.onSubmit();
        this.closeModal();
      })
      .catch((err) => {
        console.log(err);
        const o = err.data.response;
        if (o.error === '422-366') {
          this.setState({
            passwordError: '',
            passwordConfirmationError: '',
            recoveryEmailError: o.error_description,
          });
        }
      });
  }

  checkPassword(value) {
    let char_type = 0;
    if (/[A-Z]/.test(value) || /[a-z]/.test(value)) {
      char_type += 1;
    }
    if (/[0-9]/.test(value)) {
      char_type += 1;
    }
    if (/[~!@#$%^&*()_+`\-={}|[\]\\:";'<>?,./]/gi.test(value)) {
      char_type += 1;
    }
    return !(char_type < 3 || value.length < 8 || value.length > 72);
  }

  resetAuthorizationError() {
    this.setState({
      authorizationError: '',
      isRecoverPasswordLink: false,
    });
  }

  closeModal() {
    this.setState({
      isOpenModal: false,
      isNewType: false,
      isOpenSelectModal: false,
      isOpenConfirmModal: false,
      password: '',
      passwordConfirmation: '',
      passwordError: '',
      passwordConfirmationError: '',
    });
  }

  render() {
    const {
      isNewType,
      isRecoverPasswordLink,
      email,
      pass,
      passwordError,
      passwordConfirmationError,
      recoveryEmailError,
      authorizationError,
      isOpenModal,
      password,
      passwordConfirmation,
      recoveryEmail,
      isOpenSelectModal,
      isShowLoader,
      isOpenConfirmModal,
      isLoading,
    } = this.state;
    const { t } = this.props;
    const emailErrorClass = email.error ? 'show' : '';
    const passErrorClass = pass.error ? 'show' : '';

    const newPassErrorClass = passwordError !== '' ? 'show' : '';
    const confirmErrorClass = passwordConfirmationError !== '' ? 'show' : '';
    const showRecoveryEmailErrorClass = recoveryEmailError !== '' ? 'show' : '';

    return (
      <div className="login_contents">
        <div className="login_box box">
          <form onSubmit={this.onSubmit}>
            <p className="label">{t('login.menu.email')}</p>
            <input
              type="text"
              className="email"
              name="email"
              ref={this.emailRef}
              placeholder={t('login.place_holder.email')}
              autoComplete="email"
              onChange={this.resetAuthorizationError}
              onKeyPress={this.handleLogin}
            />
            <div className={`error ${emailErrorClass}`}>{email.errorMsg}</div>
            <p className="label">{t('login.menu.password')}</p>
            <input
              type="password"
              className="Password"
              name="pass"
              ref={this.passRef}
              placeholder={t('login.place_holder.password')}
              autoComplete="current-password"
              onChange={this.resetAuthorizationError}
              onKeyPress={this.handleLogin}
            />
            <div className={`error ${passErrorClass}`}>{pass.errorMsg}</div>
          </form>
        </div>
        {
          !isRecoverPasswordLink ? (
            <div className="error-full">{authorizationError}</div>
          ) : (
            <div className="error-full">
              <a className="reset" onClick={this.handleResetPassword} onKeyDown={this.handleResetPassword}>{authorizationError}</a>
            </div>
          )
        }
        <div className="button_box box">
          {
            !isLoading ? (
              <a onClick={this.onSubmit} onKeyDown={this.onSubmit} className="login_button">
                {t('login.button.sign_in')}
              </a>
            ) : (
              <a className="login_button">
                <Loader active inline size="tiny" />
              </a>
            )
          }
        </div>
        <Modal open={isOpenModal} onClose={this.closeModal} className="modal">
          <div className="modal_popup_wrap confirm_wrap">
            <div className="modal_popup_box confirm_box">
              <div className="modal_popup change_password" style={{ height: '510px' }}>
                <h2 className="title">{t('login.menu.create_new_password')}</h2>
                <p className="small_text" style={{ textAlign: 'left', whiteSpace: 'normal' }}>
                  {
                    !isNewType ? t('login.message.new_type_0') : t('login.message.new_type_1')
                  }
                </p>
                <div className="input_wrap">
                  <p className="label">
                    {t('login.menu.new_password')}
                    <em style={{ marginLeft: '0' }} className="asterisk" />
                  </p>
                  <input
                    type="password"
                    className="Password"
                    name="newPassword"
                    ref={(ref) => { this.passwordInput = ref; }}
                    placeholder={t('login.place_holder.password')}
                    value={password}
                    onChange={this.handlePasswordChange}
                    onKeyPress={this.handleConfirm}
                  />
                </div>
                <div className={`error ${newPassErrorClass}`}>{passwordError}</div>
                <div className="input_wrap">
                  <p className="label">
                    {t('login.menu.confirm_new_password')}
                    <em style={{ marginLeft: '0' }} className="asterisk" />
                  </p>
                  <input
                    type="password"
                    className="Password"
                    name="cfmNewPassword"
                    value={passwordConfirmation}
                    placeholder={t('login.place_holder.confirm_password')}
                    onChange={this.handlePasswordConfirmationChange}
                    onKeyPress={this.handleConfirm}
                  />
                </div>
                <div className={`error ${confirmErrorClass}`}>
                  {passwordConfirmationError}
                </div>
                <div className="input_wrap">
                  <p className="label">
                    {t('login.menu.recovery_email_address')}
                    <Popup
                      trigger={<Icon name="question circle outline" style={{ color: '#7434fe' }} />}
                      content={t('login.message.set_email_address')}
                      position="top left"
                      size="small"
                      className="question"
                    />
                  </p>
                  <input
                    type="text"
                    className="Password"
                    name="email"
                    value={recoveryEmail}
                    placeholder={t('login.place_holder.email_admin_account')}
                    onChange={this.handleInputRecoveryEmail}
                    onKeyPress={this.handleConfirm}
                  />
                </div>
                <div className={`error ${showRecoveryEmailErrorClass}`}>
                  {recoveryEmailError}
                </div>
                <div className="button_wrap">
                  <a onClick={this.closeModal} onKeyDown={this.closeModal} className="left_button">
                    {t('modal.button.cancel')}
                  </a>
                  {
                    !isNewType ? (
                      <a onClick={this.confirmAdmin} onKeyDown={this.confirmAdmin} className="right_button">
                        {t('modal.button.ok')}
                      </a>
                    ) : (
                      <a onClick={this.confirmAdminWithBcrypt} onKeyDown={this.confirmAdminWithBcrypt} className="right_button">
                        {t('modal.button.ok')}
                      </a>
                    )
                  }
                </div>
              </div>
            </div>
          </div>
        </Modal>
        <Modal
          open={isOpenSelectModal}
          onClose={this.closeModal}
        >
          <div className="modal_popup_wrap">
            <div className="modal_popup_box">
              {
                isShowLoader ? (
                  <CLARLoader />
                ) : (
                  <div className="modal_popup">
                    <h2 className="title">{this.modalAction}</h2>
                    <p className="text">{this.modalBody}</p>
                    <div className="button_wrap">
                      <a
                        onClick={this.closeModal}
                        onKeyDown={this.closeModal}
                        style={{ cursor: 'pointer' }}
                        className="left_button"
                      >
                        {t('modal.button.no')}
                      </a>
                      <a
                        onClick={this.resetPasswordWithToken}
                        onKeyDown={this.resetPasswordWithToken}
                        className="right_button"
                      >
                        {t('modal.button.yes')}
                      </a>
                    </div>
                  </div>
                )
              }
            </div>
          </div>
        </Modal>
        <Modal
          open={isOpenConfirmModal}
          onClose={this.closeModal}
        >
          <div className="modal_popup_wrap">
            <div className="modal_popup_box">
              <div className="modal_popup">
                <h2 className="title">{this.modalAction}</h2>
                <p className="text">{this.modalBody}</p>
                <div className="button_wrap">
                  <a
                    className="center_button"
                    style={{ cursor: 'pointer' }}
                    onClick={this.closeModal}
                    onKeyDown={this.closeModal}
                  >
                    {t('modal.button.ok')}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

export default WithRouter(withTranslation()(inject('state')(observer(Login))));
